export default {
  data() {
    return {
      modalHistory: [],
      currentModal: null,
      modalConfigs: {} // モーダル設定を保持
    }
  },

  methods: {
    /**
     * モーダル設定を登録
     * @param {string} id - モーダルID
     * @param {Object} config - モーダル設定
     * @param {Function} config.onOpen - オープン時のハンドラ
     * @param {Function} config.onClose - クローズ時のハンドラ
     */
    registerModal(id, config) {
      this.modalConfigs[id] = config;
    },

    /**
     * モーダルを開く
     * @param {string} modalId - モーダルID
     * @param {Object} inputData - 入力データ
     */
    openModal(modalId, inputData = {}) {
      const modal = document.querySelector(`#${modalId}`);
      if (!modal) return;

      // 現在開いているモーダルを非表示
      if (this.currentModal) {
        const currentModal = document.querySelector(`#${this.currentModal}`);
        if (currentModal) currentModal.style.display = 'none';
      }

      // 設定されたオープンハンドラを実行
      const config = this.modalConfigs[modalId];
      if (config?.onOpen) {
        config.onOpen.call(this, modal, inputData);
      }

      // モーダルを表示
      modal.style.display = 'block';
      document.body.classList.add('modal-body-open');
      
      // 履歴に追加
      this.modalHistory.push(modalId);
      this.currentModal = modalId;
      
      // URLにハッシュを追加
      window.history.pushState(null, null, `#${modalId}`);
    },

    /**
     * モーダルを閉じる
     * @param {string} modalId - モーダルID
     */
    closeModal(modalId) {
      const modal = document.querySelector(`#${modalId}`);
      if (!modal) return;

      // 設定されたクローズハンドラを実行
      const config = this.modalConfigs[modalId];
      if (config?.onClose) {
        config.onClose.call(this, modal);
      }

      // モーダルを非表示
      modal.style.display = 'none';
      
      // iframeがある場合はリロード
      const iframe = modal.querySelector('iframe');
      if (iframe) {
        iframe.src = iframe.src;
      }

      // 履歴から削除
      this.modalHistory = this.modalHistory.filter(id => id !== modalId);
      
      if (this.modalHistory.length === 0) {
        document.body.classList.remove('modal-body-open');
        window.history.pushState(null, null, window.location.href.split('#')[0]);
        this.currentModal = null;
      }
    },

    /**
     * モーダルトリガーのクリックハンドラ
     * @param {Event} event - クリックイベント
     */
    handleModalTriggerClick(event) {
      const trigger = event.currentTarget;
      const modalId = trigger.dataset.modalId;
      
      if (!modalId) return;

      // data-modal-input-* 属性からinputDataを構築
      const inputData = {};
      Object.keys(trigger.dataset).forEach(key => {
        if (key.startsWith('modalInput')) {
          const dataKey = key.replace('modalInput', '').toLowerCase();
          inputData[dataKey] = trigger.dataset[key];
        }
      });

      this.openModal(modalId, inputData);
    },

    /**
     * 前のモーダルに戻る
     */
    handlePrevModal() {
      if (this.modalHistory.length > 1) {
        const currentModalId = this.modalHistory.pop();
        this.closeModal(currentModalId);
        
        const prevModalId = this.modalHistory[this.modalHistory.length - 1];
        if (prevModalId) {
          this.openModal(prevModalId);
        }
      }
    },

    /**
     * モーダルのオーバーレイクリックハンドラ
     */
    handleOverlayClick() {
      if (this.currentModal) {
        this.closeModal(this.currentModal);
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      // URLハッシュによるモーダル表示の初期化
      if (window.location.hash) {
        const modalId = window.location.hash.substring(1);
        this.openModal(modalId);
      }
    });
  },

  beforeUnmount() {
    // コンポーネントのクリーンアップ時に全てのモーダルを閉じる
    if (this.currentModal) {
      this.closeModal(this.currentModal);
    }
    this.modalHistory = [];
    this.modalConfigs = {};
  }
} 